import { Box } from '@mui/material';
import React, { FC } from 'react';
import { FormView } from 'src/components/FormPart/FormView';
import { AdjustFreeCreditsForm } from './AdjustFreeCreditsForm';
import { AdjustFreeCreditsDialogViewModel } from '../../../types';
import { BhiDialog } from 'src/UIKit';

const AdjustFreeCreditsDialogView: FC<AdjustFreeCreditsDialogViewModel> = ({
  open,
  formData,
  balance,
  close,
  submit,
}) => {
  return (
    <BhiDialog isOpen={open} onClose={close} title="Adjust Free Credits" maxWidth="xs" fullWidth>
      <Box sx={{ padding: '0 20px 20px' }}>
        {/* Mounted only while open, so every opening starts from the initial form data. */}
        {open && (
          <FormView
            formData={formData}
            component={AdjustFreeCreditsForm}
            componentProps={{ balance }}
            onSubmit={submit}
          />
        )}
      </Box>
    </BhiDialog>
  );
};

export default AdjustFreeCreditsDialogView;
